import type {AiAgentChatLang} from '../../../redux/aiAgent/aiAgent.type';
import type {ChatAskPrompt} from '../../aiMessageGenerator/utils/types';

const HEBREW_LETTER = /[\u0590-\u05FF]/;

export function detectChatLangFromText(text: string): AiAgentChatLang {
    return HEBREW_LETTER.test(text) ? 'he' : 'en';
}

/**
 * Lock chatLang only on the first free-text turn — not ask-option clicks or image-only.
 */
export function shouldLockChatLang(
    prompt: string,
    pendingAsk: ChatAskPrompt | null | undefined,
): boolean {
    const trimmed = prompt.trim();
    if(!trimmed) {
        return false;
    }
    const isOptionClick = !!pendingAsk?.options?.some(opt => opt.value === trimmed);
    return !isOptionClick;
}
